var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('browse',{attrs:{"isEdit":_vm.isEdit,"type":_vm.processType,"columns":_vm.columns,"dataSource":_vm.dataSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }